import {
  isTokenSuspicious,
  isTokenSuspiciousCheck,
  suspiciousCheckData,
  SuspiciousLabelAlert,
} from '../../Wallets/labels';
import moment from 'moment';
import { ColumnsProps } from '../columns';
import { TokenIconWithChain } from 'modules/shared-components/asset/token-icon';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import { EthAddress } from 'modules/ethereum/components/EthAddress';
import { PercentageChangeWithMaxValue } from '../../TelegramCalls/columns';
import { PerformanceStyle } from '../../../../components/alerts/performanceStyle';
import { hotTokenDataMapping } from '../hotTokenDataMapping';
import { useMemo } from 'react';

export default function MobileColumn({ data, tokenStats }: ColumnsProps) {
  const mappedStats = useMemo(
    () => hotTokenDataMapping(tokenStats, data),
    [tokenStats, data]
  );

  const {
    status,
    price,
    priceChange,
    netInflowTop,
    netInflow,
    volatilityIndex,
    marketCap,
    liquidity,
  } = mappedStats;

  return (
    <div
      className={
        status === 'RUG_PULL' || isTokenSuspiciousCheck(data)
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      <div className="flex justify-between items-center ">
        <div className="">
          <div className="flex items-center xxs:gap-2">
            <div className="relative">
              <TokenIconWithChain
                hasIcon={data.hasIcon}
                tokenName={data.base}
                chain={data.chain ?? Chains.Ethereum}
                protocol={data.dex}
                symbol={data.base}
                className="w-6 h-6"
                address={data.tokenAddress}
              />
            </div>
            <div className="max-w-[120px] overflow-hidden truncate">
              <div>
                <span className=" text-sm">{data.base}</span>/
                <span className="xxs:text-dex-white-secondary xxs:text-xs">
                  {data.quote}
                </span>
              </div>
              <div>
                <EthAddress
                  className="text-xs"
                  address={data.tokenAddress}
                  precision={3}
                  kind="token"
                  chain={data.chain ?? Chains.Ethereum}
                />
              </div>
            </div>
            <SuspiciousLabelAlert
              alertItems={isTokenSuspicious(
                suspiciousCheckData(tokenStats, data)
              )}
            />
          </div>
          {data.poolCreatedAt && (
            <div className="flex items-center space-x-1 xxs:text-dex-white-secondary xxs:text-xs">
              Launch: {moment(data.poolCreatedAt).format('DD/MM/YYYY HH:mm')}
            </div>
          )}
        </div>

        <div className="xxs:space-y-0.5">
          <div className="justify-end flex flex-col items-end">
            {price ? (
              <div className="flex space-x-1 items-center">
                <PerformanceStyle
                  className="xxs:text-base"
                  isOnlyFlashEnabled={true}
                  pnl={price.toString()}
                />

                {priceChange && status !== 'RUG_PULL' && (
                  <PercentageChangeWithMaxValue
                    maxValue={999}
                    className="xxs:text-xs pt-1"
                    change={priceChange.toNumber()}
                  />
                )}
              </div>
            ) : (
              <div className="text-xs">--</div>
            )}
          </div>

          <div className="xxs:space-y-1">
            <div className="justify-end flex items-end space-x-1 ">
              <div className="flex space-x-1 items-center">
                <div>🧠</div>
                <div className=" text-xs font-bold">
                  <PerformanceStyle pnl={netInflowTop.toString()} />
                </div>
                <div>/</div>
                <div>
                  <PerformanceStyle
                    className="xxs:text-[10px]"
                    pnl={netInflow.toString()}
                  />
                </div>
              </div>

              {volatilityIndex ? (
                <div className="flex items-center space-x-1 text-xs xxs:px-1.5 xxs:py-0.5 xxs:bg-dex-black-700 lg:bg-dex-black-800 rounded">
                  <PerformanceStyle
                    noPnl={true}
                    noAsset={true}
                    pnl={volatilityIndex.mul(100).toString()}
                  />
                </div>
              ) : (
                <div className="text-xs">--</div>
              )}
            </div>
            <div className="space-x-1 flex items-center text-xs justify-end ">
              {marketCap && (
                <div className="xxs:flex xxs:space-x-1 items-center">
                  <div>🧢</div>
                  <PerformanceStyle noPnl={true} pnl={marketCap.toString()} />
                </div>
              )}
              <div>|</div>
              {liquidity && (
                <div className="xxs:flex xxs:space-x-1 items-center">
                  <div>💧</div>
                  <PerformanceStyle noPnl={true} pnl={liquidity.toString()} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
